function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M92 80h100V64H64v128h16V92l132.9 132 11.1-11.1zM420 80H320V64h128v128h-16V92L299.1 224 288 212.9zM92 432h100v16H64V320h16v100l132.9-132 11.1 11.1zM420 432H320v16h128V320h-16v100L299.1 288 288 299.1z"
});

const SvgIosExpand = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-expand.1fc04049.svg";
export { ForwardRef as ReactComponent };